<div mat-dialog-content>
    <div class="mainDiv">
      <p mat-dialog-title style="margin: 0 0 10px">
        Are you sure you want to delete this Product? Please mention the reason
        below.
      </p>
      <form [formGroup]="formDelete">
        <textarea
          type="text"
          formControlName="Remark"
          placeholder="Remark"
          maxlength="100"
          rows="3"
          style="width: 100%"
        ></textarea>
  
        <!-- <mat-error *ngIf="formDelete.get('Remark').hasError('required')">
          Please write valid reason.
        </mat-error> -->
        <div style="float: right; margin-top: 10px; margin-bottom: 13px">
          <button
            type="button"
            mat-button
            class="btn btncls"
            (click)="onSubmit('Yes')"
          >
            Delete</button
          >&nbsp;
          <button mat-button class="btn btncls" (click)="onNoClicks('No')">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
  <style>
    .btncls {
      width: 100px;
      color: white;
      background-color: #234a90;
    }
    .mat-dialog-content {
      /* display: block;
      padding: 24px;
      
      box-sizing: border-box;
      overflow: auto;
      outline: 0;
      width: 30%; */
      overflow: hidden;
      height: 93%;
      width: 104%;
      padding-right: 1px;
      border-radius: 4px;
      /* height: 100%;
      width: 100%; */
      min-height: inherit;
      max-height: inherit;
    }
    /* mat-dialog-content{
      overflow-x: hidden !important;
      overflow-y: hidden !important;
    } */
  
    .mainDiv {
      padding: 10px 20px 10px 20px;
    }
    textarea {
      resize: none;
    }
  </style>
  